import { StyledError } from '../JurisdictionView/RADECard/RADECard.styles';

export const RADENoData = () => (
  <StyledError>
    <strong>No Data Available</strong>
    <span>
      There is no information associated with this ID. Please try again. If this
      error persists, submit a ticket via the "Support" tab.
    </span>
  </StyledError>
);

export const RADEError = () => (
  <StyledError>
    <strong>An Error Occurred</strong>
    <span>
      Please try again. If this error persists, submit a ticket via the
      "Support" tab.
    </span>
  </StyledError>
);
